export default __webpack_public_path__ + "static/media/sign-up.224a1621.md";